// extracted by mini-css-extract-plugin
module.exports =  {"gig-attribute-wrapper":"F3E7f9V","gigAttributeWrapper":"F3E7f9V","gig-attribute":"Szh65RY","gigAttribute":"Szh65RY","attribute-text":"DZr8c0R","attributeText":"DZr8c0R"};